import type { DragEvent, MouseEvent } from "react";

/**
 * Props to discourage casual copying of profile/gallery/chat photos.
 *
 * Blocks: right-click menu, drag-to-desktop, iOS/Android long-press "save image".
 * NOT a real protection — screenshots, DevTools and the network tab still work.
 */
export const protectedImageProps = {
  onContextMenu: (e: MouseEvent) => e.preventDefault(),
  onDragStart: (e: DragEvent) => e.preventDefault(),
  draggable: false,
} as const;

/** Companion className: kills long-press callout and text/image selection. */
export const protectedImageClass = "select-none [-webkit-touch-callout:none]";
